import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Eye } from 'lucide-react';
import TrendingWidget from '@/components/TrendingWidget';
import WeatherWidget from '@/components/WeatherWidget';
import { EventsWidget, SportsWidget, HoroscopeWidget } from '@/components/SidebarWidgets';
import { ClassifiedsWidget, JobsWidget } from '@/components/ServiceWidgets';
import MapPage from '@/pages/public/MapPage';
import CryptoWidget from '@/components/CryptoWidget';
import SponsoredPromoWidget from '@/components/SponsoredPromoWidget';

export default function HomeSidebar({ mostRead = [], tags = [] }) {
  const { t } = useTranslation();
  return (
    <aside className="space-y-6" data-testid="home-sidebar">
      {/* Sponsored article CTA — placed at the top of the sidebar (admin request) */}
      <SponsoredPromoWidget />
      <TrendingWidget />
      <WeatherWidget />
      <ClassifiedsWidget />
      <JobsWidget />
      <MapPage compact />
      <EventsWidget />
      <SportsWidget />
      <HoroscopeWidget />
      <CryptoWidget />
      {mostRead.length > 0 && (
        <div className="bg-white dark:bg-[#0f172a] rounded-xl p-5 border border-gray-100 dark:border-gray-800" data-testid="most-read">
          <h3 className="text-sm font-bold uppercase tracking-wider text-gray-900 dark:text-gray-100 border-l-4 border-red-600 pl-3 mb-4">NAJČITANIJE 7 DANA</h3>
          <div className="space-y-3">{mostRead.map((a, i) => (
            <Link to={`/clanak/${a.slug}`} key={a.id} className="flex gap-3 group" data-testid={`most-read-${i}`}>
              <span className="text-2xl font-black text-red-500/80 shrink-0 w-8">{i + 1}</span>
              <div><h4 className="text-[13px] font-semibold text-gray-800 dark:text-gray-100 group-hover:text-red-600 line-clamp-2 leading-snug">{a.title_hr}</h4>
              <span className="text-[10px] text-gray-400 dark:text-gray-500 flex items-center gap-1 mt-1"><Eye size={10} /> {a.views}</span></div>
            </Link>
          ))}</div>
        </div>
      )}
      {tags.length > 0 && (
        <div className="bg-white dark:bg-[#0f172a] rounded-xl p-5 border border-gray-100 dark:border-gray-800" data-testid="tag-cloud">
          <h3 className="text-sm font-bold uppercase tracking-wider text-gray-900 dark:text-gray-100 border-l-4 border-blue-600 pl-3 mb-4">{t('home.all_tags')}</h3>
          <div className="flex flex-wrap gap-2">{tags.map(tag => (
            <Link key={tag.id} to={`/pretraga?q=${tag.name}`} className="px-3 py-1 text-xs bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-full text-gray-600 dark:text-gray-300 hover:bg-red-50 hover:text-red-600 dark:hover:bg-red-900/20 dark:hover:text-red-400 transition-colors">{tag.name}</Link>
          ))}</div>
        </div>
      )}
    </aside>
  );
}
